
import editIcon from "../../images/edit-icon.svg";
import { BsToggleOn, BsToggleOff } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { formatDateOrEmpty } from "../../components/CommonFunction/CommonFunction";

// const ClientsTable = ({ data = [], onToggleStatus }) => {
  const ClientsTable = ({ data = [], onToggleStatus, onEditClient }) => {
  const navigate = useNavigate();
  return (
   <div className="border rounded-md h-full min-h-0 overflow-hidden">
      <div className="h-full overflow-y-auto table-scroll">
        <table className="w-full table-fixed">
          <thead className="bg-light sticky top-0 z-10 border-b border-gray-200">
            <tr>
              <th className="w-[90px] px-3 py-2 text-left text-primary text-sm">ID</th>
              <th className="w-[160px] px-3 py-2 text-left text-primary text-sm">Name</th>
              <th className="w-[110px] px-3 py-2 text-left text-primary text-sm">Client Type</th>
              <th className="w-[130px] px-3 py-2 text-left text-primary text-sm">Parent</th>
              <th className="w-[110px] px-3 py-2 text-left text-primary text-sm">Created On</th>
              <th className="w-[80px] px-3 py-2 text-right text-primary text-sm">Licenses</th>
              <th className="w-[110px] px-3 py-2 text-left text-primary text-sm">Start Date</th>
              <th className="w-[110px] px-3 py-2 text-left text-primary text-sm">End Date</th>
              <th className="w-[80px] px-3 py-2 text-left text-primary text-sm">Status</th>
              <th className="w-[90px] px-3 py-2 text-left text-primary text-sm">Action</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={10} className="h-[240px] text-center text-sm text-gray-500">
                  No clients found
                </td>
              </tr>
            ) : (
              data.map((row) => (
                <tr key={row.id} className="border-b">
                  <td className="px-3 py-2 text-sm">{row.ClientCode}</td>

                  <td className="px-3 py-2 text-sm">
                    <div className="multi-line-ellipsis" title={row.Name}>
                      {row.Name}
                    </div>
                  </td>

                  <td className="px-3 py-2 text-sm">
                    <div className="multi-line-ellipsis" title={row.ClientType}>
                      {row.ClientType || "--"}
                    </div>
                  </td>

                  <td className="px-3 py-2 text-sm">
                    <div className="multi-line-ellipsis" title={row.ParentName}>
                      {row.ParentName || "--"}
                    </div>
                  </td>

                  <td className="px-3 py-2 text-sm">{formatDateOrEmpty(row.CreatedOn)}</td>
                  <td className="px-3 py-2 text-sm text-right tabular-nums">{row.DefaultUserCount}</td>
                  <td className="px-3 py-2 text-sm">{formatDateOrEmpty(row.LicenseStartDate)}</td>
                  <td className="px-3 py-2 text-sm">{formatDateOrEmpty(row.LicenseEndDate)}</td>

                  <td className="px-3 py-2 text-sm">
                    {row.StatusCodeId === 1 ? "Active" : "Inactive"}
                  </td>

                  <td className="px-3 py-2">
                    <div className="flex items-center gap-3">
                      <img
                        src={editIcon}
                        alt="Edit"
                        title="Edit"
                        className="cursor-pointer"
                        onClick={() => onEditClient(row)}
                      />

                      <button
                        onClick={() => onToggleStatus(row.CompanyId, row.StatusCodeId)}
                        className="cursor-pointer"
                        title={
                          row.StatusCodeId === 2
                            ? "Activate Client"
                            : "Deactivate Client"
                        }
                      >
                        {row.StatusCodeId === 1 ? (
                          <BsToggleOn size={28} color="#163D68" />
                        ) : (
                          <BsToggleOff size={28} color="#9CA3AF" />
                        )}
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientsTable;
